// Copyright Epic Games, Inc. All Rights Reserved.

import { useSelector } from "react-redux";
import {
  selectLang,
  selectLocErrorCodeDescription,
  selectLocErrorCodeTitle,
  selectLocMessage,
} from "./selectors";
import { LocalizationMessageIds } from "./reducer";

export const useErrorCodeDescription = (errorCode: string): string => {
  return useSelector(selectLocErrorCodeDescription(errorCode));
};

export const useErrorCodeTitle = (errorCode: string): string => {
  return useSelector(selectLocErrorCodeTitle(errorCode));
};

export const useIsRTL = (): boolean => {
  const lang = useSelector(selectLang);

  return lang === "ar-AR";
};

export const useLocMessage = (
  messageId: LocalizationMessageIds,
  defaultMessage: string
): string => {
  return useSelector(selectLocMessage(messageId, defaultMessage));
};
